import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { AlertService } from "src/app/services/alert.service";
import { ExpiryWarningService } from "src/app/services/expiry/expiry-warning.service";
import { SocialService } from "src/app/social/social.service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";
import { DATE_FORMATS } from "./../../services/utils";

@Component({
  selector: "app-draft-social",
  templateUrl: "./draft-social.component.html",
  styleUrls: ["./draft-social.component.scss"],
})
export class DraftSocialComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  draftCampList: any = [];
  outletId: string;
  DATE_FORMATS = DATE_FORMATS;
  campaignId: string = "None";
  itemsPerPage: number = 25;
  p: number = 1;
  pagePerItemList: any = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 75 },
    { value: 100 },
  ];
  itemList: any = [];
  typeList: any = [];
  sentType: string = "";
  reviewStartDate: any;
  public todayDate: any = new Date();
  permissions: any;
  draftCampListLen: any;
  draftTotalCount: any;
  start: any;
  end: any;
  total_draft_social_count: any;
  social_warning_text: any;
  is_social_blocked: any;
  startAt: any;
  socialVerifyF: boolean;
  socialVerifyG: boolean;
  socialVerifyI: boolean;
  postTypeList: any[] = [
    {
      name: "All",
      value: null,
    },
    {
      name: "Content",
      value: "content",
    },
    {
      name: "Image",
      value: "image",
    },
    {
      name: "Video",
      value: "video",
    },
  ];
  postType: string = "";
  searchText: string = "";
  private searchText$: Subject<string> = new Subject();

  noData: Boolean = false;
  noDataText: string = "";
  isPlatformIntegrated: boolean = false;
  dataNotFoundText = GlobalVariable.dataNotFoundText;

  constructor(
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private HttpService: DataService,
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    private commonservice: CommonService,
    private alertService: AlertService,
    private socialService: SocialService,
    private expiryWarningService: ExpiryWarningService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outletId = this.storage.get("outlet_id");
    this.connectedPlatforms();
    this.draftCampaignList(true);
    this.searchText$.pipe(debounceTime(500)).subscribe(() => {
      this.onFilter();
    });
    this.commonservice.sent_draft_social_tab_selection.subscribe((result) => {
      if (result === "SENTDRAFT") {
        this.draftCampaignList(true);
      }
    });
    const sent_campaign = this.HttpService.get(
      this.BASE_URL.SHARED_POST_FILTER_SOCIAL_V2(this.outletId)
    );
    sent_campaign.subscribe((data: Response) => {
      this.permissions = data.data["permissions"];
      // document.getElementById("upload-photo").onclick = (e: any) => {
      //   e.target.value = null;
      // };
      console.log(data);
    });

    this.startAt = this.commonservice.onDateFilter();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkExpiry();
    }, 500);
  }
  checkExpiry() {
    let divContainer: HTMLElement | null =
      document.querySelector("#expiry-modal");
    const { isExpired, expiryWarningText } =
      this.expiryWarningService.checkExpiryBasedOnProduct(
        "SOCIAL",
        divContainer
      );
    this.is_social_blocked = isExpired;
    this.social_warning_text = expiryWarningText;
  }

  public deleteBanner() {
    this.social_warning_text = "";
  }
  onSearch() {
    if (
      (this.searchText && this.searchText.length > 2) ||
      !this.searchText.length
    ) {
      this.searchText$.next();
    }
  }

  connectedPlatforms() {
    this.outletId = this.storage.get("outlet_id");
    this.HttpService.get(
      this.BASE_URL.SOCIAL_AUTH_VERIFY_URL(this.outletId)
    ).subscribe((res) => {
      if (res.data["facebook"] === "disconnected") {
        this.socialVerifyF = false;
      } else {
        this.socialVerifyF = true;
      }

      if (res.data["google"] === "disconnected") {
        this.socialVerifyG = false;
      } else {
        this.socialVerifyG = true;
      }
      if (res.data["instagram"] === "disconnected") {
        this.socialVerifyI = false;
      } else {
        this.socialVerifyI = true;
      }

      if (!this.socialVerifyG && !this.socialVerifyF && !this.socialVerifyI) {
        this.isPlatformIntegrated = false;
      } else {
        this.isPlatformIntegrated = true;
      }
      this.typeList = [
        {
          value: "social",
          title: "All",
          isConnected:
            this.socialVerifyF || this.socialVerifyG || this.socialVerifyI,
        },
        {
          value: "facebook",
          title: "Facebook",
          isConnected: this.socialVerifyF,
        },
        { value: "google", title: "Google", isConnected: this.socialVerifyG },
        {
          value: "instagram",
          title: "Instagram",
          isConnected: this.socialVerifyI,
        },
      ];
    });
  }
  reset() {
    this.reviewStartDate = undefined;
    this.start = undefined;
    this.end = undefined;
    this.sentType = "";
    this.postType = "";
    this.searchText = "";
    this.draftCampaignList();
  }

  draftCampaignList(isFirstTime: boolean = false) {
    let res: Response;
    const draft_campaign = this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.DRAFT_POST_FILTER_SOCIAL_V2(this.outletId),
      page: this.p.toString(),
      size: this.itemsPerPage.toString(),
      start: this.start ? this.start : null,
      end: this.end ? this.end : null,
      source:
        this.sentType && this.sentType !== "all" ? this.sentType : "social",
      post_type: this.postType || null,
      keyword: this.searchText || null,
    });
    draft_campaign.subscribe((data: Response) => {
      res = data;
      this.permissions = res.data["permissions"];
      this.draftCampList = res.data["campaigns"];
      this.draftTotalCount = res.data["campaigns"];
      this.total_draft_social_count = res.data["total_draft_social_count"];
      this.socialService.setTotalCount({
        count: this.total_draft_social_count,
        type: "DRAFT",
      });
      this.loading = false;
      if (isFirstTime) {
        if (this.draftCampList.length > 0) {
          this.noData = false;
        } else {
          this.noData = true;
        }
      }
    });
  }

  /**
   * Open delete popup
   */
  deleteDraftList(campaignid) {
    this.campaignId = campaignid;
    this.alertService
      .alertWithDeleteImage(
        "Delete Draft Post?",
        "Are you sure you want to delete the draft post?",
        "Delete"
      )
      .then((data) => {
        if (data.isConfirmed) {
          this.deleteDraft();
        }
      });
  }

  /**
   * Delete Campaign
   *
   * @memberof SocialComponent
   */
  deleteDraft() {
    let res: Response;
    const data_service = this.HttpService.deleteRequest({
      customApiUrl: this.BASE_URL.DELETE_SOCIAL_POST(
        this.outletId,
        this.campaignId
      ),
    });
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.campModalClose();
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.toastrService.success(res.data["message"]);

          const draft_campaign = this.HttpService.get(
            this.BASE_URL.DRAFT_POST_FILTER_SOCIAL_V2(this.outletId) +
              "?source=social"
          );
          draft_campaign.subscribe((data: Response) => {
            res = data;
            this.draftCampList = res.data["campaigns"];
            this.total_draft_social_count =
              res.data["total_draft_social_count"];
            this.socialService.setTotalCount({
              count: this.total_draft_social_count,
              type: "DRAFT",
            });
          });

          this.campModalClose();
        } else {
          this.campModalClose();
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  /**
   *  model popup close
   *
   * @memberof TeamComponent
   */
  campModalClose() {
    this.modalService.dismissAll("content");
  }

  viewDraftList(campaign_id) {
    this.campaignId = campaign_id;
    this.socialService.onEditPostRedirect(campaign_id);
  }
  onPageChange(event) {
    this.p = event;
    this.draftCampaignList();
  }
  itemsPerPageChange() {
    this.onPageChange(this.p);
  }

  onFilter() {
    this.loading = true;
    this.outletId = this.storage.get("outlet_id");

    if (this.reviewStartDate !== undefined) {
      if (this.reviewStartDate[0] !== null) {
        this.start = moment(this.reviewStartDate[0]).format("YYYY-MM-DD");
      }
    }
    if (this.reviewStartDate !== undefined) {
      if (this.reviewStartDate[1] !== null) {
        this.end = moment(this.reviewStartDate[1]).format("YYYY-MM-DD");
      }
    }
    this.p = 1;
    this.draftCampaignList();
  }

  getNoDataText() {
    if (this.isPlatformIntegrated) {
      return this.dataNotFoundText.social.draft.withIntegration;
    } else {
      return this.dataNotFoundText.social.draft.withoutIntegration;
    }
  }
}
